import { combineReducers } from 'redux';
import ui from './redux-ui/reducer';
import jigsaw from './redux-jigsaw/jigsaw-reducer';
import dev from './redux-dev/dev-reducer';
import config from './redux-watson/watson-reducer';
import bridge from './redux-bridge/bridge-reducer';
import knownClasses from './redux-known-classes/known-class-reducer';
import feeny from './redux-feeny/reducer';

export default combineReducers({
  config,
  ui,
  jigsaw,
  bridge,
  dev,
  knownClasses,
  feeny,
});
